<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.service_code" placeholder="编号" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.site" placeholder="站点" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select 
						v-model="filters.scode" filterable placeholder="选择上游" class="h-m-select">
					  <el-option v-for="item in splist"
						:key="item.scode" :label="item.sname" v-model="item.scode">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select 
						v-model="filters.cpcode" filterable placeholder="请选择渠道" class="h-m-select">
					  <el-option v-for="item in cplist"
						:key="item.code" :label="item.name" v-model="item.code">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="600">
			<el-table-column prop="entime" label="时间" min-width="100"></el-table-column>
			<el-table-column prop="service_code" label="编号" min-width="100">
				<template slot-scope="scope">
					<div>
						{{scope.row.service_code}},上游:{{scope.row.spname}}<br/>
						别名:{{scope.row.alisna+"."+scope.row.alis_index}},渠道:{{scope.row.cpname}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="site" label="站点" min-width="250">
				<template slot-scope="scope">
					<div>
						匹配:{{scope.row.site}}<br/>
						站点:{{scope.row.site_str}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="操作" fixed="right" width="150">
				<template slot-scope="scope">
					<div>
						<el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						<el-button type="text" size="small" @click="handleEditAdd(scope.$index, scope.row)">Add</el-button>
						<el-button type="text" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<!--工具条翻页-->
		<el-col :span="24" class="toolbar">
		<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;"></el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog :title="editformtitle" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm">
				<el-form-item label="编号" prop="service_code">
					<el-input v-model="editForm.service_code" placeholder="编号"></el-input>
				</el-form-item>
				<el-form-item label="匹配" prop="site">
					<el-input v-model="editForm.site" placeholder="匹配"></el-input>
				</el-form-item>
				<el-form-item label="站点" prop="site_str">
					<el-input v-model="editForm.site_str" placeholder="站点"></el-input>
				</el-form-item>
				<el-form-item label="别名" prop="alis_index">
					<el-input v-model="editForm.alis_index" placeholder="别名"></el-input>
				</el-form-item>
				<el-form-item label="上游" prop="scode">
					<el-select 
						v-model="editForm.scode" filterable placeholder="请输入/请选择" class="h-m-select">
					  <el-option v-for="item in splist"
						:key="item.scode" :label="item.sname" v-model="item.scode">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="渠道" prop="cpcode">
					<el-select 
						v-model="editForm.cpcode" filterable placeholder="请输入/请选择" class="h-m-select">
					  <el-option v-for="item in cplist"
						:key="item.code" :label="item.name" v-model="item.code">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="添加" prop="data">
					<el-input v-model="editForm.data" placeholder="时间,请求数,匹配率,展示数,点击,收益,cpc" type="textarea" :row="15"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				filters:{
					service_code:'',site:'',scode:'',cpcode:''
				},
				datalist: [],
				splist:[],
				cplist:[],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
					service_code :[
						{required: true,message: '编号不能为空!',trigger: 'blur'}
					],
					site :[
						{required: true,message: '站点不能为空!',trigger: 'blur'}
					],
					scode :[
						{required: true,message: '上游不能为空!',trigger: 'blur'}
					],
					cpcode :[
						{required: true,message: '渠道不能为空!',trigger: 'blur'}
					],
				},
				//编辑界面数据
				editForm: {
					actionurl:'',sqlid:'',entime:'',service_code:'',site:'',scode:'',cpcode:'',data:'',site_str:'',alis_index:''
				}
			}
		},
		methods: {
			getSpList(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'html_spinfo.query',
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.splist = res.data.datas;
					}
				});
				
			},
			getCpList(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'html_cpinfo.query',
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.cplist = res.data.datas;
					}
				});
				
			},
			getLists:function(){
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					actionurl:'default/getList',
					service_code:this.filters.service_code,
					site:this.filters.site,
					scode:this.filters.scode,
					cpcode:this.filters.cpcode,
					sqlid:'html_siteinfo.query'
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			},
			handleAdd:function(){
				this.editFormVisible = true;
				this.editformtitle = '新增';
				this.editForm = {
					actionurl:'default/save',sqlid:'html_siteinfo.add',entime:'',service_code:'',site:'',scode:'',cpcode:'',site_str:'',alis_index:''
				};
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'html_siteinfo.upt';
			},
			handleEditAdd: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				this.editForm.actionurl = 'datas/addAdSence';//设置Sqlid
				this.editForm.sqlid = 'html_siteinfo.upt';
			},
			editSubmit:function(){
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
			},
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
					this.listLoading = true;
					let para = {
						actionurl:'default/del',
						sqlid:'html_siteinfo.del',
						id:row.id
					};
					delData(para).then((res) => {
						this.listLoading = false;
						this.$message({message: res.data.message,type: res.data.type});
						this.getLists();
					});
				}).catch(() => {});
			}
		},
		mounted() {
			this.getCpList();
			this.getSpList();
			this.getLists();
		}
	}	
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// siteinfo.vue?7f04366b